import { Overlay } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, QueryList, TemplateRef, ViewChildren, ViewContainerRef } from '@angular/core';
import { Study } from '../../models/study.interface';
import { StudiesService } from '../../services/studies.service';

@Component({
  selector: 'app-instance-preview',
  templateUrl: './instance-preview.component.html',
  styleUrls: ['./instance-preview.component.scss']
})
export class InstancePreviewComponent implements OnInit {

  @ViewChildren('previewButton') previewButton: QueryList<ElementRef>;
  @Input() previewContainer: TemplateRef<any>;
  @Input() study: Study;
  @Output() currentPreviewChanged = new EventEmitter<string>();

  currentPreview: string;
  constructor(private readonly studiesService: StudiesService,
              private readonly overlay: Overlay,
              private readonly viewContainerRef: ViewContainerRef,) { }

  ngOnInit(): void {
  }

  openPreview(study: Study): void {
    this.currentPreview = this.studiesService.loadImage(study);
    this.currentPreviewChanged.emit(this.currentPreview);
    const origin = this.previewButton.find((button) => button.nativeElement.id === `${study.id}`);
    if (origin) {
      const overlayRef = this.overlay.create({
        hasBackdrop: true,
        positionStrategy: this.overlay.position().flexibleConnectedTo(origin)
          .withPositions([{
            originX: 'start',
            originY: 'center',
            overlayX: 'end',
            overlayY: 'center'
          }]).withPush(true),
        scrollStrategy: this.overlay.scrollStrategies.close(),
      });
      const previewPortal = new TemplatePortal(this.previewContainer, this.viewContainerRef);
      overlayRef.attach(previewPortal);
      overlayRef.backdropClick().subscribe(() => {
        overlayRef.detach();
      });
    }
  }
}
